import { createActions, handleActions } from 'redux-actions';
import selectors from './selectors';

const initialState = {
  activeCategoryName: null,
  measurements: {},
};

const ACTIVATE_MEASURE_MODE = 'DESIGN_PRO/MEASURE_MODE/ACTIVATE_MEASURE_MODE';
const SET_ACTIVE_CATEGORY_NAME =
  'DESIGN_PRO/MEASURE_MODE/SET_ACTIVE_CATEGORY_NAME';
const RESET_ACTIVE_CATEGORY_NAME =
  'DESIGN_PRO/MEASURE_MODE/RESET_ACTIVE_CATEGORY_NAME';
const UPDATE_MEASUREMENTS = 'DESIGN_PRO/MEASURE_MODE/UPDATE_MEASUREMENTS';

const actions = createActions({
  [ACTIVATE_MEASURE_MODE]: () => null,
  [SET_ACTIVE_CATEGORY_NAME]: (categoryName) => ({ categoryName }),
  [RESET_ACTIVE_CATEGORY_NAME]: () => null,
  [UPDATE_MEASUREMENTS]: (measurements) => ({ measurements }),
});

const reducer = handleActions(
  {
    [actions.designPro.measureMode.setActiveCategoryName]: (state, action) => ({
      ...state,
      activeCategoryName: action.payload.categoryName,
    }),
    [actions.designPro.measureMode.resetActiveCategoryName]: (state) => ({
      ...state,
      activeCategoryName: null,
    }),
    [actions.designPro.measureMode.updateMeasurements]: (state, action) => ({
      ...state,
      measurements: action.payload.measurements,
    }),
  },
  initialState,
);

export default {
  initialState,
  actions: actions.designPro.measureMode,
  reducer,
  selectors,
};
